import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.ROTH,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#DF252B',
    secondary: '#7C7F7E',
  },
};

export default theme;
